var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.emailAddress)?_c('a',{attrs:{"href":"mailto:"}},[(_vm.displayName)?[_vm._v(_vm._s(_vm.displayName))]:[_vm._v(_vm._s(_vm.emailAddress))]],2):(_vm.displayName)?_c('span',[_vm._v(" "+_vm._s(_vm.displayName)+" ")]):_c('span')}
var staticRenderFns = []

export { render, staticRenderFns }